import { AllowedLocales } from '#types/generated/graphql-types';
import { getCookie } from 'cookies-next';
import Router from 'next/router';
import isSSR from '#utils/is-ssr';

const getRequestLocale = (context): AllowedLocales => {
  //router locale is needed for cached pages served directly from varnish/cdn ( those requests will not reach nextJs middleware)
  const routerLocale = !isSSR() && Router?.locale;

  const locale =
    context?.locale || routerLocale || getCookie('NEXT_LOCALE') || 'de';

  return locale as AllowedLocales;
};

export default getRequestLocale;
